<template>
  <div class="grid gap-4">
    <div class="grid gap-1">
      <label class="text-[13px] font-medium text-[#dde6f3]">Stream Router</label>
      <bly-ui-select
        v-model="localConfig.streamRouterId"
        :options="streamRouterOptions"
        placeholder="Select Stream Router"
      />
    </div>

    <div class="grid gap-1">
      <label class="text-[13px] font-medium text-[#dde6f3]">Interface Name</label>
      <bly-ui-input v-model="localConfig.interfaceName" placeholder="Interface Name" />
    </div>

    <div class="mt-2 flex items-center gap-3">
      <span class="shrink-0 text-[12px] font-medium uppercase tracking-[1px] text-[#ffaa00]">
        Source Configuration
      </span>
      <div class="h-px flex-1 bg-[#2a333d]"></div>
    </div>

    <div class="grid gap-1">
      <label class="text-[13px] font-medium text-[#dde6f3]">Protocol Type</label>
      <bly-ui-select v-model="localConfig.source.type" :options="protocolOptions" />
    </div>

    <div class="grid gap-1">
      <label class="text-[13px] font-medium text-[#dde6f3]">Source URL</label>
      <bly-ui-input v-model="localConfig.source.url" placeholder="Source URL" />
    </div>

    <details
      v-if="['SRT', 'UDP', 'RTP'].includes(localConfig.source.type)"
      class="rounded-md border border-[#2a333d] bg-[#161d24]"
    >
      <summary class="cursor-pointer select-none px-3 py-2 text-[12px] font-medium text-[#dde6f3]">
        Advanced Source Settings
      </summary>
      <div class="grid gap-3 border-t border-[#2a333d] px-3 py-3 md:grid-cols-2">
        <div v-if="localConfig.source.type === 'SRT'" class="grid gap-1">
          <label class="text-[13px] font-medium text-[#dde6f3]">Latency (ms)</label>
          <bly-ui-input v-model="localConfig.source.latency" type="number" />
        </div>
        <div v-if="localConfig.source.type === 'SRT'" class="grid gap-1">
          <label class="text-[13px] font-medium text-[#dde6f3]">Max Connections</label>
          <bly-ui-input v-model="localConfig.source.max_connections" type="number" />
        </div>
        <div v-if="localConfig.source.type === 'SRT'" class="grid gap-1">
          <label class="text-[13px] font-medium text-[#dde6f3]">Passphrase</label>
          <bly-ui-input v-model="localConfig.source.passphrase" type="password" />
        </div>
        <div v-if="localConfig.source.type === 'SRT'" class="grid gap-1">
          <label class="text-[13px] font-medium text-[#dde6f3]">Stream ID</label>
          <bly-ui-input v-model="localConfig.source.stream_id" />
        </div>
        <div v-if="['UDP', 'RTP'].includes(localConfig.source.type)" class="grid gap-1">
          <label class="text-[13px] font-medium text-[#dde6f3]">TTL</label>
          <bly-ui-input v-model="localConfig.source.ttl" type="number" />
        </div>
        <div v-if="localConfig.source.type === 'SRT'" class="grid gap-1">
          <label class="text-[13px] font-medium text-[#dde6f3]">Max BW</label>
          <bly-ui-input v-model="localConfig.source.max_bw" type="number" />
        </div>
      </div>
    </details>

    <div class="mt-2 flex items-center gap-3">
      <span class="shrink-0 text-[12px] font-medium uppercase tracking-[1px] text-[#ffaa00]">
        Destination Configuration
      </span>
      <div class="h-px flex-1 bg-[#2a333d]"></div>
    </div>

    <div class="grid gap-1">
      <label class="text-[13px] font-medium text-[#dde6f3]">Protocol Type</label>
      <bly-ui-select v-model="localConfig.destination.type" :options="protocolOptions" />
    </div>

    <div class="grid gap-1">
      <label class="text-[13px] font-medium text-[#dde6f3]">Destination URL</label>
      <bly-ui-input v-model="localConfig.destination.url" placeholder="Destination URL" />
    </div>

    <details
      v-if="['SRT', 'UDP', 'RTP'].includes(localConfig.destination.type)"
      class="rounded-md border border-[#2a333d] bg-[#161d24]"
    >
      <summary class="cursor-pointer select-none px-3 py-2 text-[12px] font-medium text-[#dde6f3]">
        Advanced Destination Settings
      </summary>
      <div class="grid gap-3 border-t border-[#2a333d] px-3 py-3 md:grid-cols-2">
        <div v-if="localConfig.destination.type === 'SRT'" class="grid gap-1">
          <label class="text-[13px] font-medium text-[#dde6f3]">Latency (ms)</label>
          <bly-ui-input v-model="localConfig.destination.latency" type="number" />
        </div>
        <div v-if="localConfig.destination.type === 'SRT'" class="grid gap-1">
          <label class="text-[13px] font-medium text-[#dde6f3]">Max Connections</label>
          <bly-ui-input v-model="localConfig.destination.max_connections" type="number" />
        </div>
        <div v-if="localConfig.destination.type === 'SRT'" class="grid gap-1">
          <label class="text-[13px] font-medium text-[#dde6f3]">Passphrase</label>
          <bly-ui-input v-model="localConfig.destination.passphrase" type="password" />
        </div>
        <div v-if="localConfig.destination.type === 'SRT'" class="grid gap-1">
          <label class="text-[13px] font-medium text-[#dde6f3]">Stream ID</label>
          <bly-ui-input v-model="localConfig.destination.stream_id" />
        </div>
        <div v-if="['UDP', 'RTP'].includes(localConfig.destination.type)" class="grid gap-1">
          <label class="text-[13px] font-medium text-[#dde6f3]">TTL</label>
          <bly-ui-input v-model="localConfig.destination.ttl" type="number" />
        </div>
        <div v-if="localConfig.destination.type === 'SRT'" class="grid gap-1">
          <label class="text-[13px] font-medium text-[#dde6f3]">Max BW</label>
          <bly-ui-input v-model="localConfig.destination.max_bw" type="number" />
        </div>
      </div>
    </details>

    <div class="mt-2 flex items-center gap-3">
      <span class="shrink-0 text-[12px] font-medium uppercase tracking-[1px] text-[#ffaa00]">
        Processors & Security
      </span>
      <div class="h-px flex-1 bg-[#2a333d]"></div>
    </div>

    <div class="grid gap-2">
      <div class="flex items-center justify-between gap-3">
        <label class="text-[13px] font-medium text-[#dde6f3]">Processors</label>
        <button
          type="button"
          class="inline-flex h-7 items-center rounded-md border border-[#2a333d] bg-[#161d24] px-2.5 text-xs font-medium text-[#dde6f3] transition-colors duration-150 hover:border-[#ffaa00] hover:text-white"
          @click="addProcessor"
        >
          Add Processor
        </button>
      </div>

      <div
        v-for="(proc, index) in localConfig.processors"
        :key="'proc-' + index"
        class="grid gap-2.5 rounded-md border border-[#2a333d] bg-[#161d24] p-3"
      >
        <div class="flex items-center gap-2">
          <input
            v-model="proc.name"
            type="text"
            placeholder="Processor name"
            class="h-8 max-h-8 min-h-6 min-w-0 flex-1 rounded-sm border border-[#2a333d] bg-black/20 px-2.5 text-xs text-[#e5eefc] transition-[border-color,box-shadow] duration-150 outline-none focus:border-[#ffaa00] focus:shadow-[0_0_0_2px_rgba(255,170,0,0.18)]"
          />
          <button
            type="button"
            class="inline-flex h-6 w-6 items-center justify-center rounded-md text-[#f3b3b3] transition-colors duration-150 hover:bg-[#2a1d1d] hover:text-[#fecaca]"
            @click="removeProcessor(index)"
          >
            <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div class="grid gap-2">
          <div
            v-for="(arg, argIndex) in proc.args"
            :key="'arg-' + index + '-' + argIndex"
            class="flex items-center gap-2"
          >
            <bly-ui-input v-model="arg.key" placeholder="Key" class="w-32 shrink-0" />
            <bly-ui-input v-model="arg.value" placeholder="Value" class="min-w-0 flex-1" />
            <button
              type="button"
              class="inline-flex h-6 w-6 items-center justify-center rounded-md text-[#f3b3b3] transition-colors duration-150 hover:bg-[#2a1d1d] hover:text-[#fecaca]"
              @click="removeProcessorArg(index, argIndex)"
            >
              <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M18 6 6 18M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        <button
          type="button"
          class="inline-flex h-7 items-center self-start rounded-md border border-[#2a333d] bg-[#10161b] px-2.5 text-[12px] font-medium text-[#dde6f3] transition-colors duration-150 hover:border-[#ffaa00] hover:text-white"
          @click="addProcessorArg(index)"
        >
          Add argument
        </button>
      </div>
    </div>

    <div class="grid gap-2">
      <div class="flex items-center justify-between gap-3">
        <label class="text-[13px] font-medium text-[#dde6f3]">Whitelist (IPs)</label>
        <button
          type="button"
          class="inline-flex h-7 items-center rounded-md border border-[#2a333d] bg-[#161d24] px-2.5 text-xs font-medium text-[#dde6f3] transition-colors duration-150 hover:border-[#ffaa00] hover:text-white"
          @click="addWhitelistEntry"
        >
          Add IP
        </button>
      </div>

      <div
        v-for="(ip, index) in localConfig.whitelist"
        :key="'ip-' + index"
        class="flex items-center gap-2"
      >
        <bly-ui-input v-model="localConfig.whitelist[index]" placeholder="192.168.1.1" class="min-w-0 flex-1" />
        <button
          type="button"
          class="inline-flex h-6 w-6 items-center justify-center rounded-md text-[#f3b3b3] transition-colors duration-150 hover:bg-[#2a1d1d] hover:text-[#fecaca]"
          @click="removeWhitelistEntry(index)"
        >
          <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M18 6 6 18M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>

    <div class="grid gap-2">
      <label class="text-[13px] font-medium text-[#dde6f3]">Tags</label>
      <div v-if="localConfig.tags.length" class="flex flex-wrap gap-2">
        <span
          v-for="(tag, index) in localConfig.tags"
          :key="'tag-' + index"
          class="inline-flex items-center gap-1 rounded-full bg-[#161d24] px-2 py-1 text-[12px] text-[#dde6f3]"
        >
          {{ tag }}
          <button
            type="button"
            class="inline-flex h-4 w-4 items-center justify-center rounded-full text-[#97a5ba] transition-colors duration-150 hover:text-white"
            @click="removeTag(index)"
          >
            <svg class="h-3 w-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
        </span>
      </div>
      <div class="flex items-center gap-2">
        <bly-ui-input
          v-model="draftTag"
          placeholder="Add tag"
          class="min-w-0 flex-1"
          @keydown.enter.prevent="addTag"
        />
        <button
          type="button"
          class="inline-flex h-7 items-center rounded-md border border-[#2a333d] bg-[#161d24] px-2.5 text-xs font-medium text-[#dde6f3] transition-colors duration-150 hover:border-[#ffaa00] hover:text-white"
          @click="addTag"
        >
          Add
        </button>
      </div>
    </div>

    <div class="grid gap-2">
      <label class="text-[13px] font-medium text-[#dde6f3]">Auto-start</label>
      <label class="inline-flex items-center gap-2 text-[13px] text-[#dde6f3]">
        <input
          v-model="localConfig.autostart"
          type="checkbox"
          class="h-4 w-4 rounded border-[#2a333d] bg-[#161d24] accent-[#ffaa00]"
        />
        Auto-start Interface
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "StreamRouterInterfaceConfig",
  props: {
    value: {
      type: Object,
      required: true,
    },
    streamRouters: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      draftTag: "",
    };
  },
  computed: {
    streamRouterOptions() {
      return this.streamRouters.map((router) => ({
        value: router.id,
        label: router.name,
      }));
    },
    protocolOptions() {
      return ["SRT", "UDP", "RTP", "RTMP"].map((protocol) => ({
        value: protocol,
        label: protocol,
      }));
    },
    localConfig: {
      get() {
        this.ensureCollections();
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    ensureCollections() {
      if (!Array.isArray(this.value.processors)) this.$set(this.value, "processors", []);
      if (!Array.isArray(this.value.whitelist)) this.$set(this.value, "whitelist", []);
      if (!Array.isArray(this.value.tags)) this.$set(this.value, "tags", []);
      if (!this.value.source) this.$set(this.value, "source", {});
      if (!this.value.destination) this.$set(this.value, "destination", {});
    },
    addProcessor() {
      this.localConfig.processors.push({ name: "", args: [] });
    },
    removeProcessor(index) {
      this.localConfig.processors.splice(index, 1);
    },
    addProcessorArg(processorIndex) {
      if (!Array.isArray(this.localConfig.processors[processorIndex].args)) {
        this.$set(this.localConfig.processors[processorIndex], "args", []);
      }
      this.localConfig.processors[processorIndex].args.push({ key: "", value: "" });
    },
    removeProcessorArg(processorIndex, argIndex) {
      this.localConfig.processors[processorIndex].args.splice(argIndex, 1);
    },
    addWhitelistEntry() {
      this.localConfig.whitelist.push("");
    },
    removeWhitelistEntry(index) {
      this.localConfig.whitelist.splice(index, 1);
    },
    addTag() {
      const normalizedTag = String(this.draftTag || "").trim();
      if (!normalizedTag) return;
      if (!this.localConfig.tags.includes(normalizedTag)) {
        this.localConfig.tags.push(normalizedTag);
      }
      this.draftTag = "";
    },
    removeTag(index) {
      this.localConfig.tags.splice(index, 1);
    },
  },
};
</script>
